import React, { CSSProperties } from 'react';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

interface Props {
  status: 'Sent' | 'Saved'
}

const BroadcastStatus: React.FC<Props> = (props) => {
  const theme = useTheme();
  const { status } = props;

  const styles: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
    borderRadius: 8,
    width: 100,
    background: status === 'Sent' ? theme.palette.success.light : theme.palette.warning.light,
    color: status === 'Saved' ? theme.palette.warning.main : theme.palette.success.main,
  };

  return (
    <div style={styles}>
      <Typography variant="body2">{status === 'Saved' ? "Tersimpan" : "Terkirim"}</Typography>
    </div>
  );
};

export default BroadcastStatus;
